import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { NewEntryPage } from '~/features/entry-form/new-entry-page';

/**
 * `?sign=in|out` opens a both-ways record on that way, as a Cash in or a Cash
 * out button means it to. `?stocking=1` is a list being filled for the first
 * time, from the field that will read it: the title says "Add to …".
 */
const search = z.object({
  sign: z.enum(['in', 'out']).optional().catch(undefined),
  stocking: z.coerce.boolean().optional().catch(undefined),
});

/** A new entry is a page of its own (web-redesign-05 Decided 7), for a record and for a list. */
function NewEntryRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { sign, stocking } = Route.useSearch();
  return <NewEntryPage key={recordId} recordId={recordId} direction={sign} stocking={stocking === true} />;
}

export const Route = createFileRoute('/_app/records/$recordId/new-entry')({
  validateSearch: search,
  component: NewEntryRoute,
});
